import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, Download, RotateCcw, Smartphone, Star } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-116">
      {/* Background blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-cardPink rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-117"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-cardPurple rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-118"></div>

      <div className="relative z-10 flex flex-col lg:flex-row items-center gap-12" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex-1 text-center lg:text-left" data-id="element-120">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-brand-primary font-semibold text-sm mb-6 shadow-sm" data-id="element-121">
            <Star className="w-4 h-4 fill-brand-primary" data-id="element-122" />
            <span data-id="element-123">+2,400 MUJERES YA LA TIENEN</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-brand-dark leading-tight mb-6" data-id="element-124">
            Por fin una guía que te explica TODO sobre tu píldora
            anticonceptiva...{' '}
            <span className="text-brand-primary" data-id="element-125">
              sin términos médicos complicados, sin miedo y sin juicios
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-brand-secondary mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-126">
            La guía completa que toda mujer merece tener: cómo tomarlas
            correctamente, qué hacer si olvidas una dosis, efectos secundarios
            reales y el sistema de seguimiento que te mantiene protegida todos
            los días.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-4 mb-8" data-id="element-127">
            <div className="flex items-center gap-4 text-2xl sm:text-3xl font-bold" data-id="element-128">
              <span className="text-gray-400 line-through text-xl sm:text-2xl" data-id="element-129">
                $19.99
              </span>
              <span className="text-brand-accent text-4xl sm:text-5xl" data-id="element-130">
                $11.99
              </span>
            </div>

            <CTAButton className="w-full sm:w-auto" data-id="element-131">
              💊 QUIERO MI GUÍA AHORA POR $11.99
            </CTAButton>
          </div>

          <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm text-brand-secondary font-medium" data-id="element-132">
            <span className="flex items-center gap-1" data-id="element-133">
              <Lock className="w-4 h-4" data-id="element-134" /> Pago seguro
            </span>
            <span className="hidden sm:inline text-brand-cardPink" data-id="element-135">•</span>
            <span className="flex items-center gap-1" data-id="element-136">
              <Download className="w-4 h-4" data-id="element-137" /> Descarga instantánea
            </span>
            <span className="hidden sm:inline text-brand-cardPink" data-id="element-138">•</span>
            <span className="flex items-center gap-1" data-id="element-139">
              <RotateCcw className="w-4 h-4" data-id="element-140" /> Garantía 7 días
            </span>
            <span className="hidden sm:inline text-brand-cardPink" data-id="element-141">•</span>
            <span className="flex items-center gap-1" data-id="element-142">
              <Smartphone className="w-4 h-4" data-id="element-143" /> Cualquier dispositivo
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex-1 relative w-full max-w-md lg:max-w-full" data-id="element-144">
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative rounded-[2rem] border-8 border-white shadow-2xl overflow-hidden bg-white aspect-[4/5] mx-auto max-w-sm" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/uY8uqDzj7yHUkewnswcYgi/portada_anticonceptivos.png" alt="Guía Completa de Anticonceptivos Orales" className="w-full h-full object-cover" data-id="element-146" />
            {/* Tablet glare effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-white/30 pointer-events-none" data-id="element-147"></div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}